import type { HyperEntityConfig } from "@shared/backend/hyper-entity.decorator";
import { isVolunteerOrgContactRoleKind } from "@shared/helpers/volunteer-organization";
import { Roles } from "@shared/Roles";
import { remult } from "remult";
import type { VolunteerOrganizationContact } from "./entity";

export const VolunteerOrganizationContactEntityConfig: HyperEntityConfig<VolunteerOrganizationContact> =
  {
    allowApiRead: true,
    allowApiCrud: Roles.AdminsAndManager,
    apiPrefilterPerRole: (filter) => {
      if (!remult.user) return;
      filter(Roles.AdminsAndManager, true);
      filter(Roles.User, false);
    },
    allowInsertPerRole(allow) {
      allow(Roles.AdminsAndManager, true);
    },
    allowDeleteAndUpdatePerRole(allow) {
      allow(Roles.AdminsAndManager, true);
    },
    saving(entity) {
      if (!entity.volunteerOrganizationId?.trim()) {
        throw new Error("ארגון חובה");
      }
      if (!isVolunteerOrgContactRoleKind(entity.roleKind)) {
        throw new Error("תפקיד איש הקשר לא תקין");
      }
      entity.roleLabel = entity.roleLabel?.trim() ?? "";
      const name = entity.name?.trim() ?? "";
      const phone = entity.phone?.trim() ?? "";
      const email = entity.email?.trim() ?? "";
      if ((phone || email) && !name) {
        throw new Error("יש למלא שם לאיש קשר");
      }
      entity.name = name || null;
      entity.phone = phone || null;
      entity.email = email || null;
    },
  };
